module.exports = __webpack_public_path__ + "img/279.b7c7c97e.jpg";